module.exports = __webpack_public_path__ + "static/img/slide1.f543f3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slide1.png
// module id = Hhdd
// module chunks = 8